import linkedin from '../assets/linkedin.png';
import git from '../assets/git.png';
import './Contact.css';
import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ContactMe = () =>{

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs
          .sendForm('service_rhzwycj', 'template_obndzlp', form.current, {
            publicKey: 'YnKu49KcklG5SNnIz',
          })
          .then(
            () => {
              console.log('SUCCESS!');
              e.target.reset();
              toast.success('Email Send');
            },
            (error) => {
              console.log('FAILED...', error.text);
            },
          );
      };

      
    return(
        <>
        <h2 className="conhead">You Can Contact Me here</h2> 
        <div className="contact" id="contact">
            <form className="contactform" ref={form} onSubmit={sendEmail}>
        <input type="text" className="name" placeholder="Your Name" name="user_name"/>
        <input type="email" className="email" placeholder="Your Email" name="user_email" />
        <textarea  className="msg" rows='5' placeholder="Your Message" name="message"></textarea>
        <button type="submit" value='Send' className="btn btn-success">Submit</button>
            </form>
                <h2 className="conf">Follow Me On</h2> 
            <div className="links"> 
            <a href='https://www.linkedin.com/in/aashish-lal0201/' rel="noreferrer" target='_blank'><img src={linkedin} alt="LinkedIn" className="link"/></a>
           <a href='https://github.com/Aashish-011' rel="noreferrer" target='_blank'> <img src={git} alt="Git Hub" className="link"/></a>
            </div>
        </div>

        </>
)};